/**
 * AuditService
 * Service for audit log operations
 * Route: api/audit
 */
import { BaseService } from '../base/BaseService';
/**
 * AuditService
 * Handles audit log operations including login attempts and user activity history
 */
export class AuditService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AuditService.DEFAULT_SERVICE_PATH,
            basePath: AuditService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET LOGIN ATTEMPTS ====================
    /**
     * Get login attempts with optional filtering by user
     * GET api/audit/login-attempts?userId={userId}&page=1&pageSize=50
     */
    async getLoginAttempts(params) {
        const response = await this.getLoginAttemptsRaw(params);
        return response.data ?? [];
    }
    /**
     * Get login attempts with full response
     */
    getLoginAttemptsRaw(params) {
        const endpoint = this.getEndpoint('login-attempts', 'login-attempts');
        const url = this.buildUrlWithParams(endpoint, params);
        return this.http.get(url);
    }
    // ==================== GET RECENT FAILED ATTEMPTS ====================
    /**
     * Get recent failed login attempts for a specific email
     * GET api/audit/recent-failures/{email}?minutes=15
     */
    async getRecentFailedAttempts(email, minutes = 15) {
        const response = await this.getRecentFailedAttemptsRaw(email, minutes);
        return response.data ?? [];
    }
    /**
     * Get recent failed attempts with full response
     */
    getRecentFailedAttemptsRaw(email, minutes = 15) {
        const endpoint = this.getEndpoint('recent-failures', `recent-failures/${encodeURIComponent(email)}`);
        const url = this.buildUrlWithParams(endpoint, { minutes });
        return this.http.get(url);
    }
    // ==================== GET MY LOGIN HISTORY ====================
    /**
     * Get current user's login history
     * GET api/audit/my-login-history?page=1&pageSize=20
     */
    async getMyLoginHistory(page = 1, pageSize = 20) {
        const response = await this.getMyLoginHistoryRaw(page, pageSize);
        return response.data ?? [];
    }
    /**
     * Get my login history with full response
     */
    getMyLoginHistoryRaw(page = 1, pageSize = 20) {
        const endpoint = this.getEndpoint('my-login-history', 'my-login-history');
        const url = this.buildUrlWithParams(endpoint, { page, pageSize });
        return this.http.get(url);
    }
}
AuditService.DEFAULT_SERVICE_PATH = 'users';
AuditService.BASE_PATH = 'api/audit';
//# sourceMappingURL=AuditService.js.map